import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { collateralApi, ApiError } from '../services/collateralApi';

export default function useCreditRightBatchPageView() {
    const navigate = useNavigate();
    const { batchId } = useParams<{ batchId: string }>();
    const [refreshKey, setRefreshKey] = useState(0);
    const [batch, setBatch] = useState<any | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [resending, setResending] = useState(false);

    const fetchData = useCallback(async () => {
        if (!batchId) return;
        setIsLoading(true);
        try {
            const result = await collateralApi.getCreditRightBatch(batchId);
            setBatch(result);
        } catch (e: any) {
            if (e instanceof ApiError) {
                if (e.status === 403) return navigate('/denied');
                if (e.status === 404) return navigate('/not-found');
            }
            navigate('/error');
        } finally {
            setIsLoading(false);
        }
    }, [batchId, navigate]);

    useEffect(() => { fetchData(); }, [fetchData, refreshKey]);

    const refresh = () => setRefreshKey(k => k + 1);

    const resendFailed = async () => {
        const ids = (batch?.items || []).filter((i: any) => i.canResend).map((i: any) => Number(i.id));
        if (ids.length === 0) return;
        setResending(true);
        try {
            const res = await collateralApi.resendCreditRights(ids);
            toast.success(`Reenvio disparado (${res?.resent ?? 0} de ${res?.requested ?? ids.length}).`);
            refresh();
        } catch (e: any) {
            toast.error(e?.data?.message || 'Falha ao reenviar os registros do lote.');
        } finally {
            setResending(false);
        }
    };

    const hasResendableItems = (batch?.items || []).some((i: any) => i.canResend);

    return { batch, isLoading, resending, resendFailed, hasResendableItems, refresh };
}
